import { useI18n } from '../i18n';

export default function Services() {
  const { t } = useI18n();
  const items = t('services.items');

  return (
    <section id="services" className="bg-[#FFFBEB] px-6 py-24">
      <div className="mx-auto max-w-7xl">
        <div className="mb-16 max-w-2xl">
          <h2 className="font-['Russo_One'] text-4xl uppercase text-[#0F172A] md:text-5xl">
            {t('services.title')}
          </h2>
          <p className="mt-4 text-lg text-[#78350F]">{t('services.subtitle')}</p>
        </div>
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {Array.isArray(items) &&
            items.map((item, idx) => (
              <article
                key={idx}
                className="group border-2 border-[#FDE68A] bg-white p-6 transition-all duration-200 hover:border-[#F59E0B] hover:shadow-[8px_8px_0px_0px_#F59E0B]"
              >
                <div className="mb-4 flex h-12 w-12 items-center justify-center bg-[#F59E0B] text-[#0F172A]">
                  <span className="font-['Russo_One'] text-xl">{String(idx + 1).padStart(2, '0')}</span>
                </div>
                <h3 className="font-['Russo_One'] text-xl uppercase text-[#0F172A]">{item.title}</h3>
                <p className="mt-3 text-[#78350F]">{item.description}</p>
              </article>
            ))}
        </div>
      </div>
    </section>
  );
}
